export const PROMOTION_TYPE = {
  MANUAL: 'manual',
  BOGOF: 'bogof',
  MULTI_BUY: 'multi-buy',
  MEAL_DEAL: 'meal-deal',
  REDUCED_PRICE: 'reduced-price'
}